/**
 * 催收服务统计 - 添加录入
 */
import React, { PureComponent } from 'react';
import { Form, Input, Button, Modal, Row, Col, message, DatePicker, InputNumber } from 'antd-v5';
import dayjs from 'dayjs';
import { addPayEntryDataRequest } from '../../../state/request/payEntryData';

const FormItem = Form.Item;

const isIntegerAmount = (value) => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return Number.isInteger(Number(value));
};

class AddRecordItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
    this.formRef = null;
  }

  // 添加记录
  handleSubmit = async (values) => {
    const {
      businessCode,
      contactPhone,
      debtorName,
      debtorPhone,
      creditAmount,
      latestCreditTime,
      delegateCreateTime,
      totalRepaymentAmount,
    } = values;

    this.setState({ loading: true });

    const params = {
      businessCode,
      contactPhone,
      debtorName,
      debtorPhone,
      creditAmount: creditAmount ?? null,
      latestCreditTime: latestCreditTime ? latestCreditTime.valueOf() : null,
      delegateCreateTime: delegateCreateTime ? delegateCreateTime.valueOf() : null,
      totalRepaymentAmount:
        totalRepaymentAmount === undefined || totalRepaymentAmount === null
          ? null
          : Math.trunc(Number(totalRepaymentAmount)),
    };

    const { code } = await addPayEntryDataRequest(params);
    this.setState({ loading: false });

    if (code === 200) {
      message.success('添加成功');
      this.props.onClose();
      this.props.onRefresh();
    }
  };

  render() {
    const { visible, onClose } = this.props;
    const { loading } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <div className='modal-box'>
        <Modal
          title='添加录入'
          open={visible}
          onCancel={onClose}
          footer={null}
          width='800px'
          destroyOnClose
          maskClosable={false}
        >
          <Form
            {...formItemLayout}
            ref={(r) => {
              this.formRef = r;
            }}
            onFinish={this.handleSubmit}
            layout='horizontal'
            initialValues={{
              delegateCreateTime: dayjs(),
            }}
          >
            <Row gutter={24}>
              <Col span={12}>
                <FormItem
                  label='商行业务ID'
                  name='businessCode'
                  rules={[{ required: true, message: '请输入商行业务ID!' }]}
                >
                  <Input placeholder='请输入商行业务ID' maxLength={64} allowClear />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label='联系人手机号'
                  name='contactPhone'
                  rules={[
                    { required: true, message: '请输入联系人手机号!' },
                    {
                      pattern: /^((\+)?86|((\+)?86)?)0?1\d{10}$/,
                      message: '请输入正确的手机号格式',
                    },
                  ]}
                >
                  <Input placeholder='请输入联系人手机号' maxLength={11} allowClear />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem
                  label='被追讨人姓名'
                  name='debtorName'
                  rules={[{ required: true, message: '请输入被追讨人姓名!' }]}
                >
                  <Input placeholder='请输入被追讨人姓名' maxLength={32} allowClear />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label='被追讨人手机号'
                  name='debtorPhone'
                  rules={[
                    { required: true, message: '请输入被追讨人手机号!' },
                    {
                      pattern: /^((\+)?86|((\+)?86)?)0?1\d{10}$/,
                      message: '请输入正确的手机号格式',
                    },
                  ]}
                >
                  <Input placeholder='请输入被追讨人手机号' maxLength={11} allowClear />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem label='追讨标的金额' name='creditAmount'>
                  <InputNumber
                    placeholder='请输入追讨标的金额'
                    style={{ width: '100%' }}
                    min={0}
                    precision={2}
                    controls={false}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label='最近一次赊欠时间' name='latestCreditTime'>
                  <DatePicker
                    style={{ width: '100%' }}
                    format='YYYY-MM-DD'
                    placeholder='请选择最近一次赊欠时间'
                    // disabledDate={(current) => {
                    //   return current && current > dayjs().endOf('day');
                    // }}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem label='委托记录创建时间' name='delegateCreateTime'>
                  <DatePicker
                    style={{ width: '100%' }}
                    format='YYYY-MM-DD'
                    placeholder='请选择委托记录创建时间'
                    // disabledDate={(current) => {
                    //   return current && current > dayjs().endOf('day');
                    // }}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label='回款金额'
                  name='totalRepaymentAmount'
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value === undefined || value === null || value === '') {
                          return Promise.resolve();
                        }
                        if (Number(value) < 0) {
                          return Promise.reject(new Error('回款金额不能小于 0'));
                        }
                        if (!isIntegerAmount(value)) {
                          return Promise.reject(new Error('回款金额不允许为小数'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    placeholder='请输入回款金额'
                    style={{ width: '100%' }}
                    min={0}
                    precision={0}
                    step={1}
                    controls={false}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row style={{ textAlign: 'center', marginTop: 24 }}>
              <Col span={24}>
                <Button onClick={onClose}>关闭</Button>
                <Button
                  type='primary'
                  htmlType='submit'
                  loading={loading}
                  style={{ marginLeft: 18 }}
                >
                  保存
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default AddRecordItem;
